<template>
  <div class="max-w-xl mx-auto">
    <img v-if="team.companyLogo" class="mb-4 h-16 w-auto m-auto" :src="team.companyLogo" />
    <div class="flex flex-col text-center">
      <h3 class="text-lg font-medium leading-6 text-gray-900 mr-2">{{ record.title }} - Application</h3>
      <p class="mt-1 text-sm text-gray-500 max-w-lg mx-auto">
        Please fill out the application as accurately as possible. After submitting we will review your application and
        get back to you as soon as possible.
      </p>
    </div>
    <Card extra-classes="mt-8">
      <div v-if="applicationSuccess && !schedulingImmediately" class="mt-1 text-center text-sm text-gray-500">
        We have successfully received your application! Thanks for applying. We will get back to you with next steps as
        soon as possible.
        <img
          v-if="team.zipId && $route.query.utm_source == 'zip_recruiter'"
          :src="`https://track.ziprecruiter.com/conversion?enc_account_id=${team.zipId}`"
          width="1"
          height="1"
        />
      </div>
      <div v-if="applicationSuccess && schedulingImmediately" class="mt-1 text-center text-sm text-gray-500">
        We have successfully received your application! Thanks for applying. We will redirect you in 3 seconds to
        schedule your initial interview.
        <img
          v-if="team.zipId && $route.query.utm_source == 'zip_recruiter'"
          :src="`https://track.ziprecruiter.com/conversion?enc_account_id=${team.zipId}`"
          width="1"
          height="1"
        />
      </div>
      <div v-else>
        <ApplicationForm :record="record" @update:model-value="handleApplicationUpdate" />
        <div class="mt-8">
          <TButton label="Submit application" color="indigo" :disabled="!isValid" @click="submitApplication"></TButton>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import DetailForm from '../shared/DetailForm.vue';
import ApplicationForm from './ApplicationForm.vue';
import Card from '../Card/index.vue';

export default {
  components: {
    Card,
    DetailForm,
    ApplicationForm,
  },
  props: ['record', 'team'],
  data() {
    return {
      loading: true,
      application: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        reLicenseNumber: '',
        resume: '',
        notLicensedAgent: false,
        courseworkStarted: false,
        courseworkNotStarted: false,
        licensedAgent: false,
        contactMethodsOptIn: false,
      },
      applicationSuccess: false,
      schedulingImmediately: false,
      isValid: false,
    };
  },
  computed: {
    isInvalid() {
      return !this.isValid;
    },
    attributionParams() {
      const params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
      const { query } = this.$route;

      let full = {};

      params.forEach(param => {
        if (query[param]) {
          full[param] = query[param];
        }
      });

      return full;
    },
  },
  methods: {
    handleApplicationUpdate({ application, isValid }) {
      this.application = application;
      this.isValid = isValid;
    },
    submitApplication() {
      const self = this;
      let formData = new FormData();

      const id = self.$route.params.id;

      if (/^[a-f0-9]{12}$/.test(id)) {
        formData.append('indeed_ref_id', id);
      } else {
        const [v2JobId, jobDetailId, jobLocationId] = id.split('-');
        formData.append('v2_job_id', v2JobId);
        formData.append('job_detail_id', jobDetailId);
        formData.append('job_location_id', jobLocationId);
      }

      formData.append('first_name', self.application.firstName);
      formData.append('last_name', self.application.lastName);
      formData.append('phone_number', self.application.phone);
      formData.append('email', self.application.email);
      formData.append('re_license_number', self.application.reLicenseNumber);
      formData.append('opt_in', self.application.contactMethodsOptIn);
      let hasLicense = self.application.licensedAgent && !self.application.notLicensedAgent ? true : false;
      formData.append('has_license', hasLicense);
      let isCourseworkStarted =
        self.application.courseworkStarted && !self.application.courseworkNotStarted ? true : false;
      formData.append('is_coursework_started', isCourseworkStarted);
      formData.append('attribution_params', JSON.stringify(self.attributionParams));
      self.application.resume ? formData.append('resume', self.application.resume) : null;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch('/public/applications', {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0]?.content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.applicationSuccess = true;
            if (data.success_action === 'schedule_immediately') {
              self.$store.commit('general/showAlert', {
                alertType: 'success',
                alertTitle: 'Application submitted',
                alertDescription:
                  'Your application was successfully submitted. We will redirect you to schedule your first interview in 3 seconds.',
              });
              self.schedulingImmediately = true;
              setTimeout(() => {
                window.location.href = data.success_redirect_url;
              }, 3000);
            } else {
              self.$store.commit('general/showAlert', {
                alertType: 'success',
                alertTitle: 'Application submitted',
                alertDescription: 'Your application was successfully submitted.',
              });
            }
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Application submission error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
